import type { CSSProperties } from 'react';

import MarkdownContent from '../common/MarkdownContent';
import RichDocContent from '../common/RichDocContent';
import type { RichTextBlock } from '../../api/staticPageBlocks';
import { isRichDoc } from '../../api/staticPageRichText';

interface RichTextBlockViewProps {
  block: RichTextBlock;
  assetUrls?: Record<string, string>;
}

const RichTextBlockView = ({ block, assetUrls }: RichTextBlockViewProps) => (
  <div
    className="block-rich-text"
    data-columns={block.columns.length}
    style={{ '--cols': block.columns.length } as CSSProperties}
  >
    {block.columns.map((column, i) => (
      <div className="block-rich-text__col" key={i}>
        {isRichDoc(column) ? (
          <RichDocContent doc={column} assetUrls={assetUrls} />
        ) : (
          <MarkdownContent content={column} />
        )}
      </div>
    ))}
  </div>
);

export default RichTextBlockView;
